import { CreditAccountType } from "@/types/profile";

export const isDepartmentCreditType = (
  type: CreditAccountType,
): type is Extract<CreditAccountType, "massage" | "beauty" | "pet"> => {
  const validTypes = ["massage", "beauty", "pet"];
  return validTypes.includes(type);
};

export const getDepartmentCreditLabel = (type: CreditAccountType): string => {
  if (type === "massage") return "Massage";
  if (type === "beauty") return "Beauty";
  if (type === "pet") return "Pet Care";
  return "";
};

export const getDepartmentLinkedName = (
  type: CreditAccountType,
): string | null => {
  if (type === "massage") return "MASSAGE";
  if (type === "beauty") return "HOME_BEAUTY";
  if (type === "pet") return "PET_CARE";
  return null;
};
